<template>
 <div class="mobile-wrapper">
  <header class="header">
    <h1 class="header-title"><img src="/logo_snowswap_white.svg" class="header-image" alt="SnowSwap" /></h1>
  
    <p class="header-desc">Currently desktop-only</p>
    <p class="header-desc header-desc-sm">Mobile version coming soon!</p>
  </header>

  <swiper ref="slider" class="slider" :options="swiperOptions">
    <swiper-slide class="slider-item">
      <img src="/mobile-slide1.svg" class="slider-image" alt="Swap image">
      <h2 class="slider-title">Swap like-kind DeFi assets</h2>
      <p class="slider-text">Swap between different DeFi assets using our stableswap platform</p>
    </swiper-slide>

    <swiper-slide class="slider-item">
      <img src="/mobile-slide2.svg" class="slider-image" alt="Deposit image">
      <h2 class="slider-title">Deposit DeFi tokens</h2>
      <p class="slider-text">Deposit your assets in the pools to earn a share of trading fees</p>
    </swiper-slide>

    <swiper-slide class="slider-item">
      <img src="/mobile-slide3.svg" class="slider-image" alt="Liquidity image">
      <h2 class="slider-title">Liquidity mining</h2>
      <p class="slider-text">Stake your liquidity provider tokens to earn SNOW governance tokens</p>
    </swiper-slide>

    <div class="slider-pagination" slot="pagination"></div>
  </swiper>

  <footer class="footer">
    <div class="socials">
      <a
        class="s-btn-social"
        target="_blank"
        rel="noopener noreferrer"
        href="https://twitter.com/snow_swap"
      >
        <img src="/twitter.svg" alt="Twitter" />
      </a>

      <a
        class="s-btn-social"
        target="_blank"
        rel="noopener noreferrer"
        href="https://medium.com/snowswap"
      >
        <img src="/medium.svg" alt="Medium" />
      </a>

      <a
        class="s-btn-social"
        target="_blank"
        rel="noopener noreferrer"
        href="https://discord.gg/CSSJTs4"
      >
        <img src="/discord.svg" alt="Discord" />
      </a>

      <a
        class="s-btn-social"
        target="_blank"
        rel="noopener noreferrer"
        href="https://t.me/Snowswap_community"
      >
        <img src="/telegram.svg" alt="Telegram" />
      </a>
    </div>

    <p class="footer-text">
      Secured by 
      
      <a href="https://hackmd.io/@9GUQpanJRF6cloQ0fwyPFw/r1_ctUuqv" target="_blank">
        <img src="/quantstamp-mobile.svg" class="footer-text-image" alt="Quantstamp logo" />
      </a>
    </p>
  </footer>
</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "mobileLanding",
  components: { Swiper, SwiperSlide },
  computed: {
    swiper() {
      return this.$refs.slider.$swiper
    },
  },
  data() {
    return {
      swiperOptions: {
        autoplay: true,
        slidesPerView: 1,
        pagination: {
          el: '.slider-pagination'
        },
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.header{
  height: 280px;
  padding-top: 50px;
  margin-bottom: 23px;
  text-align: center;
  box-sizing: border-box;
  background: url("../../assets/mobile-background.jpg") no-repeat center top/100% 100%;

  &-image{
    height: 50px;
  }

  &-title{
    margin: 0 0 -4px;
  }

  &-desc{
    margin: 0;
    color: #fff;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: -7px;
    letter-spacing: -0.6px;
    
    &-sm{
      margin: 0;
      font-size: 14px;
      letter-spacing: -0.2px;
    }
  }
}

.slider{
  &-item{
    text-align: center;
  }

  &-image{
    margin-bottom: 29px;
  }

  &-title{
    margin: 0 0 12px;
    color: #414a5b;
    font-size: 26px;
    line-height: 18px;
  }

  &-text{
    margin: 0 auto 24px;
    color: #414a5b;
    font-size: 18px;
    line-height: 140%;
    max-width: 260px;
  }

  &-pagination{
    position: static;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep .swiper-pagination-bullet-active {
      width: 12px;
      height: 12px;
      background: #00B9C2;
    }
  }
}

.footer{
  margin: 0;
  padding: 24px 0;
  background: #fff;

  &-text{
    margin: 0;
    color: #414a5b;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-image{
      margin-left: 10px;
    }
  }
}

.socials{
  width: 100%;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  & .s-btn-social{
    width: 42px;
    height: 42px;
    margin: 0 2px;
  }
}
</style>
